import { render, staticRenderFns } from "./documents.accountspayable.student.vue?vue&type=template&id=2abc9c09&scoped=true"
import script from "./documents.accountspayable.student.vue?vue&type=script&lang=js"
export * from "./documents.accountspayable.student.vue?vue&type=script&lang=js"
import style0 from "./documents.accountspayable.student.vue?vue&type=style&index=0&id=2abc9c09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abc9c09",
  null
  
)

export default component.exports